export default "__VITE_ASSET__d300d2b8__"